export default __webpack_public_path__ + "static/media/HelpVideo.b8a72892.mp4";